import api from './api'

/**
 * Person Service
 * Handles all person-related API calls
 */
class PersonService {
  /**
   * Get all persons from a club
   * GET v1/{club}/persons
   */
  async getPersons(clubUuid: string): Promise<any> {
    const response = await api.get(`v1/${clubUuid}/persons`)
    return response.data
  }
}

export default new PersonService()
